import {ControllerFlowAPI} from '@wix/yoshi-flow-editor'
import type {ExpressCheckoutButtonsState} from '@wix/ecom-platform-express-checkout-buttons'

import {isTemplateView} from '../../utils/flowAPI'
import {EXPERIMENTS} from '../../utils/constants'

export enum ExpressCheckoutMode {
  Off = 'off',
  Demo = 'demo',
  Live = 'live',
}

export const EXPRESS_CHECKOUT_NO_BUTTONS_STATE =
  'LOADED_WITHOUT_BUTTONS' as ExpressCheckoutButtonsState.LOADED_WITHOUT_BUTTONS

export const getExpressCheckoutMode = (flowAPI: ControllerFlowAPI): ExpressCheckoutMode => {
  const {isEditor, isPreview, isSSR} = flowAPI.environment

  if (!flowAPI.experiments.enabled(EXPERIMENTS.tableReservationsExpressCheckout) || isSSR) {
    return ExpressCheckoutMode.Off
  }

  return isEditor || isPreview || isTemplateView(flowAPI)
    ? ExpressCheckoutMode.Demo
    : ExpressCheckoutMode.Live
}
